
import { SortParams, paramsDefault } from '@/shared/interfaces/sortParams.model';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'CitiesList',

	props: {
		cities: Array,
	},

	data() {
		return {
			sortParams: paramsDefault as SortParams,
		};
	},

	methods: {
		sortBy(orderBy: string) {
			this.sortParams = { orderBy: orderBy, order: !this.sortParams.order };
			this.$emit('onSortCities', this.sortParams);
		},
	},
});
